import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {POLL_OPTION,POLL_OPTION_WEB} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";
import {pollQuestionFilterMixin} from "../FilterMixin";

export default {
    mixins: [DatatableHelperMixin,pollQuestionFilterMixin],
    data() {
        return {
            options: {
                name: this.$t('pollOptions.title'),
                url: POLL_OPTION,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('pollOptions.option_text'),
                        type: 'text',
                        key: 'option_text',
                        isVisible: true,
                    },
                    {
                        title: this.$t('pollQuestion'),
                        type: 'custom-html',
                        key: 'poll_question',
                        isVisible: true,
                        modifier: poll_question => {
                            return poll_question.question_text
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('pollQuestion'),
                        type: "multi-select-filter",
                        key: "pollQuestions",
                        option: [],
                        listValueField: 'question_text',
                        permission: !!this.$can('view_poll_questions')
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: POLL_OPTION_WEB,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-poll-option-modal',
                        modalId: 'poll-option-modal',
                        url: POLL_OPTION,
                        name: 'edit',
                        modifier: row => this.$can('update_poll_option')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'poll-option-modal',
                        url: POLL_OPTION,
                        name: 'delete',
                        modifier: row => this.$can('delete_poll_option')
                    },
                ],
            }
        }
    }
}
